import React, { Component, Fragment } from "react";

import _ from 'lodash';
import { connect } from "react-redux";
import { compose } from "redux";
import styled from 'styled-components';
import {Grid} from '@material-ui/core';

import {resetTestData} from 'store/state/calculators';
import CapForm from './CapForm';
import CapCosts from './CapCosts';
import GridPricing from './GridPricing';

const Results = styled.div`  
  height:100%;
  width:100%;
  margin-right:50px;
`;
class CapPricer extends Component {

  componentDidMount(){
    if(this.props.capResult != {}) {
      this.props.resetTestData();
    }
  }

  shouldRenderResult = (capResult) => {
    return capResult.marketCost;
  }
  render() {
    const { capResult } = this.props;      
    return (
      <Fragment>
        <Grid container>
          <CapForm/>
          <Grid item xs={false} md={false} lg={2}/>
          <Grid container item xs={9} md={8} lg={6}>
            {this.shouldRenderResult(capResult) && <Results>
              <CapCosts capResult={capResult}/>
              <GridPricing capResult={capResult}/>
            </Results>}
          </Grid>
      </Grid>
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  const { calculators, loading} = state;

  return {      
    loading,
    capResult: calculators.capPricer.capResult
  };
};

export default compose(
  connect(
    mapStateToProps,
    {resetTestData,}
  ),  
)(CapPricer);